export default __webpack_public_path__ + "static/hinduShrine-b0023935fe074b13dad5be9ee158bd74.svg";